__turbopack_context__.v({
  "header": "TopDestinations-module-scss-module__pUNifW__header",
  "root": "TopDestinations-module-scss-module__pUNifW__root",
});
